exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span._25NoP{cursor:pointer}span._2HS6d,span._25NoP{font-size:16px;margin:0 8px}._1L5V_{color:#777;font-style:italic}._11A3G{background:#f3d8d8;color:#8b0000}._2y1Zx{background:#f9fad2}.rsRaf{background:#d2e7fa}._1NiFl{padding:0!important}._1p2Xh{padding:7px;line-height:24px}.FWp57{padding:7px 3px;line-height:30px}._2mcxG div{overflow-x:hidden!important}._2mcxG div div div div{overflow:hidden!important}", ""]);

// exports
exports.locals = {
	"btn": "_25NoP",
	"info": "_2HS6d",
	"sinSnapshot": "_1L5V_",
	"facturaCancelada": "_11A3G",
	"conCambios": "_2y1Zx",
	"conActualizaciones": "rsRaf",
	"tdClear": "_1NiFl",
	"field": "_1p2Xh",
	"fieldAsignacion": "FWp57",
	"hidden": "_2mcxG"
};